import { CleanupIsins } from "./CleanupIsins";

export default {
    create: CleanupIsins
};

